// Generated by ReScript, PLEASE EDIT WITH CARE


var consentModalTitle = "Gizliliğinize saygı duyuyoruz!";

var consentModalDescription = "Size daha iyi bir kullanıcı deneyimi sunmak için çerezleri kullanıyoruz: Çerez politikamız hakkında daha fazla bilgiyi şu adresten alabilirsiniz <a href='/cookie-policy' data-cc='show-preferencesModal'>here</a>";

var showPreferencesBtn = "Çerez ayarlarını düzenleyin";

var acceptAllBtn = "Hepsini kabul et";

var acceptNecessaryBtn = "Tümünü reddet";

var savePreferencesBtn = "Tercihleri ​​Onayla";

var closeIconLabel = "Kapalı";

var preferencesModalTitle = "Çerez Tercihleri";

var preferencesModalDescription = "Çerez kullanımına izin vermeniz halinde verileriniz yurt içinde ve yurt dışında işlenecektir. Çerezler hakkında daha detaylı bilgi için yazımızı okuyabilirsiniz <a href='/cookie-policy' class='cc__link'>Çerez politikası</a>.";

var necessaryCookiesTitle = "Kesinlikle Gerekli Çerezler";

var necessaryCookiesDescription = "Sistemlerin izlenmesi ve sorunların raporlanması için kullanılır";

var functionalTitle = "Fonksiyonel Çerezler";

var functionalDescription = "İşlevselliği ve deneyimi geliştirmek için kullanılır";

var analyticsAndPerformanceTitle = "Analitik/Performans Çerezi";

var analyticsAndPerformanceDescription = "Web sitemizi geliştirmemize ve kullanıcı dostu hale getirmemize yardımcı olmak için";

var marketingTitle = "Pazarlama Çerezleri";

var marketingDescription = "Ücret tahmin formunu gönderirken isim, cep telefonu numarası gibi kişisel veriler. Facebook tarafından kullanılan kampanya ayrıntıları ve diğer ilgili veriler";

export {
  consentModalTitle ,
  consentModalDescription ,
  showPreferencesBtn ,
  acceptAllBtn ,
  acceptNecessaryBtn ,
  savePreferencesBtn ,
  closeIconLabel ,
  preferencesModalTitle ,
  preferencesModalDescription ,
  necessaryCookiesTitle ,
  necessaryCookiesDescription ,
  functionalTitle ,
  functionalDescription ,
  analyticsAndPerformanceTitle ,
  analyticsAndPerformanceDescription ,
  marketingTitle ,
  marketingDescription ,
}
/* No side effect */
